export default {
  email: /[A-Za-z0-9_]+([-+.'][A-Za-z0-9_]+)*@[A-Za-z0-9_]+([-.][A-Za-z0-9_]+)*\.[A-Za-z0-9_][A-Za-z0-9_]+([-.][A-Za-z0-9_]+)*/,
  phoneNumber: /^[\\+](([4][1][7][35-9]\d{7})|(([1-35-9]\d|[4][02-9])\d{6,}))$/
}
